/**
Author - Venkatesh Pullaganti😃
Git - https://github.com/venkatesh1146
**/

import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import {ActionButton, ActionButtonSecondary} from 'screens/commons';

const propTypes = {
  statusMessage: PropTypes.shape({
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    image: PropTypes.string,
  }).isRequired,
  errorMessage: PropTypes.string,
  showUploadButton: PropTypes.bool.isRequired,
  onUpload: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
  showRefreshButton: PropTypes.bool,
};

const StatusView = ({
  statusMessage,
  errorMessage,
  showUploadButton,
  onUpload,
  isLoading,
  showRefreshButton,
}) => {
  const reloadWindow = () => {
    window.location.reload();
  };
  return (
    <StatusContainer>
      {statusMessage.image && <StatusImage src={statusMessage.image} alt={statusMessage.title} />}
      <StatusTitle>{statusMessage.title}</StatusTitle>
      <StatusDescription>{statusMessage.description}</StatusDescription>
      {errorMessage && <ErrorMessage>Reason: {errorMessage}</ErrorMessage>}
      {showUploadButton && (
        <StyledActionButton
          buttonText="Upload Income Declaration"
          callback={onUpload}
          isLoading={isLoading}
          isDisabled={isLoading}
        />
      )}
      {showRefreshButton && (
        <>
          <InfoText>
            Facing any issue while verification? Click the refresh button below to retry
          </InfoText>
          <StyledSecondaryButton buttonText="Refresh" callback={reloadWindow} />
        </>
      )}
    </StatusContainer>
  );
};

const StatusContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 3rem;
  padding: 2rem;
  border-radius: 12px;
  width: 100%;
  max-width: 500px;
`;

const StatusImage = styled.img`
  width: 80px;
  height: 80px;
  object-fit: contain;
`;

const StatusTitle = styled.h2`
  margin-top: 1.5rem;
  color: #000000;
  font-weight: 600;
  font-size: 1.25rem;
  text-align: center;
`;

const StatusDescription = styled.p`
  margin-top: 1rem;
  color: #4b5563;
  text-align: center;
  line-height: 1.6;
`;

const ErrorMessage = styled.p`
  color: #dc2626;
  font-size: 0.875rem;
  text-align: center;
  margin: 1rem 0;
  padding: 0.75rem;
  background: #fee2e2;
  border-radius: 6px;
  width: 100%;
`;

const StyledActionButton = styled(ActionButton)`
  width: 100%;
  max-width: 600px;
  margin-top: 2rem;
`;

const StyledSecondaryButton = styled(ActionButtonSecondary)`
  width: 100%;
  max-width: 600px;
  margin-top: 1rem;
`;

const InfoText = styled.p`
  margin-top: 1rem;
  margin-bottom: 0;
  font-size: 0.875rem;
  color: #4b5563;
  text-align: center;
`;

StatusView.propTypes = propTypes;

export default StatusView;
